export default __webpack_public_path__ + "images/BBQ.4947ca.jpg";